import * as Video from "twilio-video";
import { ConnectOptions, LocalTrack, Room } from "twilio-video";
import { useCallback, useEffect, useRef, useState } from "react";

import { SidebarContent } from "components/Meeting/Live/VideoProvider";

import { LiveRoomAccessDetails } from "store/meetings/types";
import { SingleVoting } from "store/voting/types";

// @ts-ignore
window.TwilioVideo = Video;

export const useRoom = (
  localTracks: LocalTrack[],
  onError: (error: Error) => void,
  options?: ConnectOptions
) => {
  const [room, setRoom] = useState<Room | null>(null);
  const [isConnecting, setIsConnecting] = useState(false);
  const [sidebarContent, setSidebarContent] = useState<SidebarContent>(null);
  const [agendaOpened, setAgendaOpened] = useState(false);
  const [agendaSmall, setAgendaSmall] = useState(false);
  const [liveVoting, setLiveVoting] = useState<SingleVoting | null>(null);
  const optionsRef = useRef(options);

  useEffect(() => {
    optionsRef.current = options;
  }, [options]);

  const connect = useCallback(
    (accessDetails: LiveRoomAccessDetails) => {
      setIsConnecting(true);
      return Video.connect(accessDetails.access_token, {
        ...optionsRef.current,
        name: accessDetails.sid,
        tracks: localTracks,
        dominantSpeaker: true,
      }).then(
        (newRoom) => {
          setRoom(newRoom);
          const disconnect = () => newRoom.disconnect();
          newRoom.setMaxListeners(100);

          newRoom.once("disconnected", () => {
            setTimeout(() => setRoom(null));
            window.removeEventListener("beforeunload", disconnect);
          });

          // @ts-ignore
          window.twilioRoom = newRoom;

          newRoom.localParticipant.videoTracks.forEach((publication) =>
            publication.setPriority("low")
          );

          setIsConnecting(false);

          //Event on browser close
          window.addEventListener("beforeunload", disconnect);
        },
        (error) => {
          onError(error);
          setIsConnecting(false);
        }
      );
    },
    [localTracks, onError]
  );

  return {
    room,
    isConnecting,
    connect,
    sidebarContent,
    setSidebarContent,
    agendaOpened,
    setAgendaOpened,
    liveVoting,
    setLiveVoting,
    agendaSmall,
    setAgendaSmall,
  };
};
